import { render, staticRenderFns } from "./ElementView.vue?vue&type=template&id=52770a78&scoped=true"
import script from "./ElementView.vue?vue&type=script&lang=js"
export * from "./ElementView.vue?vue&type=script&lang=js"
import style0 from "./ElementView.vue?vue&type=style&index=0&id=52770a78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52770a78",
  null
  
)

export default component.exports